"use client";

import ServerContentBlocks from "./ServerContentBlocks";
import WhistlerRouteServerContent from "./WhistlerRouteServerContent";
import type { PaintBlock } from "@/lib/painted-content";
import type { RouteContent } from "@/lib/whistler-route-content";

/** Render the server's snapshot synchronously on both sides of hydration. Passing data instead of
 * streamed React children prevents production hydration from reclaiming an already-entered wrapper
 * when a child Flight record arrives late. This still SSRs the full, visible no-JavaScript content. */
export default function ExportContentBody({ blocks, images, liveFacts, routeContent, paint, tabs, currentPath }: {
  blocks: readonly PaintBlock[];
  images: readonly { src: string; alt?: string; width?: number | string | null; height?: number | string | null }[];
  liveFacts: readonly { label: string; value: string }[];
  routeContent: RouteContent | null;
  paint: boolean;
  tabs?: Readonly<Record<string, string>>;
  currentPath?: string;
}) {
  return (
    <div data-sg-route-content="" style={{ overflowX: "auto", maxWidth: "100%", padding: "24px 16px" }}>
      {routeContent ? <WhistlerRouteServerContent content={routeContent} /> : null}
      <ServerContentBlocks blocks={blocks} paint={paint} tabs={tabs} currentPath={currentPath} />
      {images.map((image, i) => (
        <img key={`i${i}`} src={image.src} alt={image.alt ?? ""} loading="lazy"
          {...(image.width ? { width: image.width } : {})}
          {...(image.height ? { height: image.height } : {})} />
      ))}
      {liveFacts.length > 0 && (
        <dl data-live-facts="">
          {liveFacts.map((fact) => (
            <div key={fact.label} data-live-fact={fact.label}>
              <dt>{fact.label}</dt><dd>{fact.value}</dd>
            </div>
          ))}
        </dl>
      )}
    </div>
  );
}
